var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconStoreList = function SvgIconStoreList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9527",
    "data-name": "Grupo 9527",
    transform: "translate(445 16.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6367",
    "data-name": "Caminho 6367",
    d: "M-445-9.923c.214-.392.409-.8.645-1.173,1.041-1.65,2.1-3.288,3.14-4.938a.97.97,0,0,1,.888-.511q7.338.011,14.676,0a.953.953,0,0,1,.869.5c1.148,1.812,2.3,3.624,3.463,5.421a1.868,1.868,0,0,1,.26,1.506,3.145,3.145,0,0,1-2.1,2.516,2.679,2.679,0,0,1-2.956-.85c-.038-.041-.078-.08-.131-.134a2.873,2.873,0,0,1-2.247,1.125,2.863,2.863,0,0,1-2.24-1.116,2.837,2.837,0,0,1-4.515-.008,2.884,2.884,0,0,1-2.232,1.125,2.851,2.851,0,0,1-2.251-1.113c-.211.189-.4.391-.622.554-1.774,1.336-4.238.151-4.6-2.207-.012-.076-.032-.15-.048-.225Z",
    transform: "translate(0 0)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6368",
    "data-name": "Caminho 6368",
    d: "M-398.8,152.98v.3q0,4.083,0,8.165c0,1.226-.591,1.9-1.666,1.9h-1.278v-8.383h-4.427v8.383H-417.8c-1.046,0-1.649-.682-1.649-1.867q0-4.122,0-8.244v-.281c.266.069.514.15.767.2a3.858,3.858,0,0,0,2.75-.471.3.3,0,0,1,.339-.006,3.953,3.953,0,0,0,4.094,0,.3.3,0,0,1,.34.008,3.948,3.948,0,0,0,4.074,0,.326.326,0,0,1,.361.007,3.952,3.952,0,0,0,4.054,0,.3.3,0,0,1,.339-.018,3.785,3.785,0,0,0,3.387.342A.944.944,0,0,1-398.8,152.98Zm-17.689,6.987h5.871v-5.01h-5.871Z",
    transform: "translate(-23.868 -160.892)",
    fill: "#191750"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStoreList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_store_list.4969a965.svg";
export { ForwardRef as ReactComponent };